"use client";

import { useCallback } from "react";

import { useAuthorization } from "./authorization-context";
import {
  checkPolicy,
  type PolicyDefinition,
  type PolicyResult,
} from "./policy";

/**
 * クライアント側でポリシー評価を行うフック。
 * 関数インスタンスを `useCallback` で安定化させ、依存配列にそのまま渡しても差分検知が暴れないようにしています。
 */
export function useCheckPolicy() {
  const authorization = useAuthorization();

  return useCallback(
    <TArgs = void>(
      policy: PolicyDefinition<typeof authorization, TArgs>,
      args?: TArgs,
    ): PolicyResult => {
      if (args === undefined) {
        return checkPolicy(policy, authorization);
      }
      return checkPolicy(policy, authorization, args);
    },
    [authorization],
  );
}
